import { render, staticRenderFns } from "./purge-movement.vue?vue&type=template&id=7476fb61"
import script from "./purge-movement.vue?vue&type=script&lang=js"
export * from "./purge-movement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports